import { render, staticRenderFns } from "./GroupGender.vue?vue&type=template&id=4df5e897&scoped=true"
import script from "./GroupGender.vue?vue&type=script&lang=js"
export * from "./GroupGender.vue?vue&type=script&lang=js"
import style0 from "./GroupGender.vue?vue&type=style&index=0&id=4df5e897&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df5e897",
  null
  
)

export default component.exports